import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { selectActiveForgotPasswordSession } from '../../reducers/forgot-password'
import { selectActiveLoginSession } from '../../reducers/login'
import { selectActiveRegistrationSession } from '../../reducers/registration'
import { removeNotification, selectList } from '../../state/notifications'


const mapStateToProps = createStructuredSelector({
    activeForgotPasswordSession: selectActiveForgotPasswordSession,
    activeLoginSession: selectActiveLoginSession,
    activeRegistrationSession: selectActiveRegistrationSession,
    notifications: selectList
})

const mapDispatchToProps = {
    removeNotification
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)
